import api from './api';

export default {
  getAll() {
    return api.get('/blog-posts');
  },
  getById(id: number) {
    // Backend show accepts slug or ID
    return api.get(`/blog-posts/${id}`);
  },
  create(data: any) {
    return api.post('/blog-posts', data);
  },
  update(id: number, data: any) {
    return api.put(`/blog-posts/${id}`, data);
  },
  delete(id: number) {
    return api.delete(`/blog-posts/${id}`);
  }
};
